import { FC } from 'react';
import {
  NotificationResponsesView,
  WellbeingResponsesView,
} from './responses-view';

export const NotificationResponsesPanel: FC = () => (
  <>
    <div className="pt-7">
      <NotificationResponsesView />
    </div>
  </>
);

export const WellbeingResponsesPanel: FC = () => (
  <>
    <div className="pt-7">
      <WellbeingResponsesView />
    </div>
  </>
);
